export default __webpack_public_path__ + "static/media/9.b77e73ff.jpg";